import React, { Component } from 'react';
import { withRouter, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import * as queryString from 'query-string';

import PowerEventUpgrade from '../../components/Upgrade/UpgradeToPowerPopUp/PowerEventUpgrade';
import CheckoutForm from '../../components/CheckoutForm';

import { stripePlans } from '../../utils/constants';

import styles from './powerPage.scss';

class PowerPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showCheckout: false,
            selectedInterval: 'year',
        };

        this.handleClick = this.handleClick.bind(this);
        this.handleSuccess = this.handleSuccess.bind(this);
    }

    handleClick(ev, interval) {
        const parsed = queryString.parse(this.props.location.search);
        let newInterval = interval;
        if (parsed.plan) {
            if (parsed.plan === stripePlans.members.powerMonthly) {
                newInterval = 'month';
            } else {
                newInterval = 'year';
            }
        }
        this.setState({ showCheckout: true, selectedInterval: newInterval });
    }

    handleSuccess() {
        this.props.history.replace('/home');
    }

    render() {
        const titleTexts = {
            search: 'Advanced Search is available exclusively for Power Users',
            college_module: 'College tools are available exclusively for Power Users',
            premium_clubs: 'Premium clubs are available exclusively for Power Users',
            player_stats: 'Rating history is available exclusively for Power Users',
            event_discount: 'Discounted registration is available exclusively for Power Users',
            messaging: 'Messaging players is available exclusively for Power Users',
            personal_club_limit: '8+ friends in your club is available exclusively for Power Users',
            personal_club_paid_event: 'Paid events are available exclusively for Power users',
        };

        const subtitleTexts = {
            college_module: 'Access college reports, Team6 ratings, and compare college rosters against any other player.',
            premium_clubs: '',
            player_stats: '',
            event_discount: 'Register for unlimited verified events at a discounted price',
            messaging: '',
            personal_club_limit: '',
            personal_club_paid_event: '',
        };
        const { showCheckout } = this.state;
        const { auth, type } = this.props;
        const { user } = auth;

        if (user) {
            if (user.isPowered) {
                return <Redirect to={`/home`} status={302} />;
            }
        } else {
            this.props.history.push(`/join?return=/power`);
        }

        return (
            <React.Fragment>
                <div className={`${styles.powerPage}`}>
                    <div className="container bg-transparent">
                        <div className="row">
                            <div className="col-md-6 offset-md-3">
                                { showCheckout
                                    ? <CheckoutForm formType="powered" interval={this.state.selectedInterval} onComplete={this.handleSuccess} />
                                    : (
                                        <PowerEventUpgrade
                                            titleText={type ? titleTexts[this.props.type] : 'Get exclusive benefits for Power Users'}
                                            subtitleText={type ? subtitleTexts[this.props.type] : ''}
                                            onClick={this.handleClick}
                                            referral={true}
                                        />
                                    )}
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}
function mapStateToProps({ auth }) {
    return { auth };
}

export default withRouter(connect(mapStateToProps)(PowerPage));
